import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { logoutStatic } from "../../StateManagement/authSlice";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { DropDownFormat } from "../../Landing/Components/FormOptions/DropDownFormat";
import { getProvince } from "../../StateManagement/ProvinceSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const InsuranceForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const api = "http://api.nanopardazan.com/taab30.aspx";
  const [educationList, seteducationList] = useState([]);
  const [checkLogin, setCheckLogin] = useState(null);
  const [selectedEdu, setSelectedEdu] = useState(null);
  const [initialValues, setInitialValues] = useState([]);
  const [choicesInheritance, setChoicesInheritance] = useState("");
  const [cityList, setCityList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);
  const [born, setBorn] = useState("");
  const [job, setJob] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [educationId, setEduationId] = useState(null);
  const [insuranceId, setInsuranceId] = useState(null);
  const province = useSelector((state) => state?.province?.province);
  const [selectedInheritance, setSelectedInheritance] = useState(true);
  const mapOptions = (apiResponse) => {
    return apiResponse?.map((item) => ({
      value: item.EduId,
      label: item.EduTitle,
    }));
  };

  const defaultValues = {
    name: "",
    family: "",
    mob: "",
    idcode: "",
    shsh: "",
    birthday: new Date(),
    height: "",
    weight: "",
    Job: "",
  };

  const {
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    register,
    formState: { errors },
  } = useForm({ defaultValues });
  useEffect(() => {
    dispatch(getProvince());
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const data = mapOptions(province);
    setProvinceList(data);
  }, []);
  const handleCityResponse = (response) => {
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.cityid,
        label: item.cityname,
      }));
    };
    const data = mapOptions(response);
    setCityList(data);
  };
  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("province"));
      fetchData("city", bodyFormData, handleCityResponse);

      // try {
      //     const response = await axios.post(BASE_URL, bodyFormData, {
      //         headers: {
      //             "Content-type": "multipart/form-data",
      //             'Accept': 'application/json',
      //             'cmd': 'city'
      //         },
      //     });
      //     if (response.status === 200) {
      //         const data = await response.data

      //         return data?.dt
      //     } else {
      //         throw new Error(`HTTP error! Status: ${response.status}`);
      //     }
      // } catch (error) {
      //     throw error;
      // }
    };
    if (!watch("province")) {
      setCityList([]);
      return;
    }
    // fetchData().then(value => {
    //     const mapOptions = (apiResponse) => {
    //         return apiResponse?.map(item => ({
    //             value: item.cityid, label: item.cityname
    //         }));
    //     };
    //     const data = mapOptions(value)
    //     setCityList(data)
    // })
  }, [watch("province")]);

  const handleApiResponse = (data) => {
    setCheckLogin(data?.UserId);
    reset({ ...defaultValues });
  };
  const fetchInitialData = async (id) => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyFormData, handleApiResponse);

    // try {

    //     const response = await axios.post(BASE_URL, bodyFormData, {
    //         headers: {
    //             "Content-type": "multipart/form-data",
    //             'Accept': 'application/json',
    //             'cmd': 'guid'
    //         },
    //     });
    //     if (response.status === 200) {
    //         const data = await (response?.data)
    //         setCheckLogin(data?.UserId)
    //         reset({...defaultValues})
    //         return data
    //     } else {
    //         throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    // } catch (error) {
    //     throw error;
    // }
  };

  useEffect(() => {
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, [checkLogin]);
  const fetchData = async () => {};
  const onSubmit = async (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("step", 1);
    bodyFormData.append("idcode", data?.idcode);
    bodyFormData.append("shsh", data?.shsh);
    bodyFormData.append("name", data?.name);
    bodyFormData.append("family", data?.family);
    bodyFormData.append("height", data?.height);
    bodyFormData.append("weight", data?.weight);
    bodyFormData.append("job", data?.job);
    bodyFormData.append("birthday", new Date(data?.birthday));
    bodyFormData.append("mob", data?.mob);
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("updateinsurance", bodyFormData, handleUpdateResponse);
    const handleUpdateResponse = (data) => {
      setCheckLogin(data?.UserId);
      setInsuranceId(data?.insuranceid);
      console.log(data?.insuranceid);
      // onNext(data?.insuranceid)
    };
    // try {
    //     const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
    //         headers: {
    //             'cmd': 'createinsurance',
    //             'Content-Type': "multipart/form-date",
    //         },
    //     });
    //     if (responseGlobal.status === 200) {
    //         const data = responseGlobal.data;
    //         // setGlobalData(data)
    //         setCheckLogin(data?.UserId)
    //         setInsuranceId(data?.insuranceid)
    //         console.log(data?.insuranceid)
    //         onNext(data?.insuranceid)
    //         // SweetAlert({
    //         //     title: '',
    //         //     text: 'اطلاعات تکمیلی با موفقیت ذخیره شد.',
    //         //     type: 'success',
    //         // });
    //     } else {
    //         console.error(`API request failed with status: ${responseGlobal.status}`);
    //     }
    // } catch (error) {
    //     console.error("Error while fetching menu data:", error);
    // }
  };
  useEffect(() => {
    fetchInitialData();
  }, []);
  let rowcount = 1;
  const [tableData, setTableData] = useState([
    { insid: insuranceId, name: "", relation: "", idcode: "", bd: "" },
  ]);

  const handleInputChange = (e, id, index, column) => {
    const newTableData = [...tableData];
    newTableData[index] = {
      ...newTableData[index],
      [column]: e.target.value,
    };

    console.log("awd");
    setTableData(newTableData);
  };
  const handleAddRow = () => {
    const newRow = {
      insid: insuranceId,
      id: rowcount,
      name: ``,
      relation: "",
      idcode: "",
      bd: "",
    };
    rowcount += 1;

    setTableData((prevData) => [...prevData, newRow]);
  };
  return (
    <>
      <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2 mb-1"
        onClick={() => navigate(-1)}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
      <PanelContainer title={"بیمه نامه"}>
        <>
          <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="name"
                  type={"text"}
                  label="نام"
                  errors={errors}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="family"
                  type={"text"}
                  label="نام خانوادگی"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="mob"
                  type={"tel"}
                  defaultValue={""}
                  maxLength={"11"}
                  label="شماره موبایل"
                  errors={errors}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="job"
                  type={"text"}
                  label="شغل"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="idcode"
                  type={"tel"}
                  maxLength={"11"}
                  defaultValue={""}
                  label="کدملی"
                  errors={errors}
                />
              </Col>{" "}
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  maxLength={"10"}
                  name="shsh"
                  type={"tel"}
                  defaultValue={""}
                  label="شماره شناسنامه"
                  errors={errors}
                />
              </Col>
            </Row>{" "}
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="height"
                  type={"tel"}
                  defaultValue={""}
                  label="قد"
                  maxLength={"3"}
                  errors={errors}
                />
                {/*    <InputFormat control={control} name='Email' type={'text'} label='ایمیل' errors={errors}/>*/}
              </Col>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="weight"
                  type={"tel"}
                  defaultValue={""}
                  label="وزن"
                  maxLength={"3"}
                  errors={errors}
                />{" "}
                {/*    <InputFormat control={control} name='PassWord' type={'password'} label='رمز عبور'*/}
                {/*                 errors={errors}/>*/}
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6 ">
                <Form.Group className="mb-3 w-75 ">
                  <Form.Label className="fw-bold pb-1">تاریخ تولد</Form.Label>
                  <Controller
                    control={control}
                    name="birthday"
                    rules={{ required: true }} //optional
                    render={({ field }) => (
                      <>
                        <DatePicker
                          className="txt-center"
                          {...field}
                          format={"YYYY-MM-DD"}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          defaultValue={"1996-12-02T12:01:39.860Z"}
                        />
                        {errors.BirhDay && <span>تاریخ تولد الزامی است</span>}
                      </>
                    )}
                  />
                </Form.Group>
              </Col>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="fathername"
                  type={"text"}
                  label="نام پدر"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="born"
                  type={"text"}
                  label="محل تولد"
                  errors={errors}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="borncity"
                  type={"text"}
                  label="محل صدور"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6">
                <TelInput
                  label="کد پستی"
                  type="text"
                  name="postalcode"
                  control={control}
                  defaultValue={""}
                />
              </Col>
              <Col className=" col-12 col-lg-6 ">
                <Form.Group
                  className="mb-3 d-flex flex-column  drop-down-group "
                  controlId="formBasicEdu"
                >
                  <Form.Label className="fw-bold pb-1">جنسیت </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    {...register("sex", {
                      required: "جنسیت الزامی است",
                    })}
                    className={"w-75"}
                  >
                    <option value="" disabled>
                      انتخاب کنید...
                    </option>
                    <option value="1">مرد</option>
                    <option value="2">زن</option>
                  </Form.Select>
                </Form.Group>
                {errors.sex && (
                  <div className="text-danger">{errors.sex.message}</div>
                )}
              </Col>
            </Row>
            <Row></Row>
            <Row>
              <Col className="col-12 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"استان"}
                  options={ProvinceList}
                  errors={errors}
                  name={"province"}
                />
              </Col>
              <Col className="col-12 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"شهر"}
                  options={cityList}
                  errors={errors}
                  name={"city"}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6 lg-w-50">
                <InputFormat
                  control={control}
                  name="address"
                  type={"textarea"}
                  label="آدرس"
                  errors={errors}
                />
              </Col>
              <Col className=" col-6 col-lg-2">
                <InputFormat
                  control={control}
                  name="no"
                  type={"text"}
                  label="پلاک "
                  errors={errors}
                />
              </Col>

              <Col className=" col-6 col-lg-2">
                <InputFormat
                  control={control}
                  name="unit"
                  type={"text"}
                  label="واحد"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6 ">
                <Form.Group
                  className="mb-3 d-flex flex-column  drop-down-group "
                  controlId="formBasicEdu"
                >
                  <Form.Label className="fw-bold pb-1">وضعیت تاهل </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    {...register("married", {
                      required: "تاهل الزامی است",
                    })}
                    className={"w-75"}
                  >
                    <option value="" disabled>
                      انتخاب کنید...
                    </option>
                    <option value="1">مجرد</option>
                    <option value="2">متاهل</option>
                  </Form.Select>
                </Form.Group>
                {errors.sex && (
                  <div className="text-danger">{errors.sex.message}</div>
                )}
              </Col>
              <Col className=" col-12 col-lg-6 ">
                <Form.Group
                  className="mb-3 d-flex flex-column  drop-down-group "
                  controlId="formBasicEdu"
                >
                  <Form.Label className="fw-bold pb-1">وراث </Form.Label>
                  <Form.Select
                    className="w-75"
                    defaultValue={""}
                    aria-label="Default select example"
                    onChange={(e) => {
                      setChoicesInheritance(e.target.value);
                      // if (e.target.value === "2") {
                      // } else {
                      //   setChoicesInheritance(false);
                      // }
                    }}
                  >
                    <option value="" disabled>
                      انتخاب کنید...
                    </option>
                    <option value="1">وراث قانونی</option>
                    <option value="2">وراث انتخابی</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col className="col-12  ">
                {selectedInheritance && (
                  <div class="table-responsive">
                    <table className="table">
                      <thead>
                        <tr className="">
                          <th>نام و نام خانوادگی</th>
                          <th>نسبت ذی نفع</th>
                          <th>کدملی ذی نفع</th>
                          <th>تاریخ تولد</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((row, index) => (
                          <tr key={row.id}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={row.column1}
                                onChange={(e) =>
                                  handleInputChange(e, row.id, index, "name")
                                }
                              />
                            </td>
                            <td>
                              <select
                                defaultValue={""}
                                className="form-select"
                                value={row.column2}
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    row.id,
                                    index,
                                    "relation"
                                  )
                                }
                              >
                                <option value="" disabled>
                                  انتخاب کنید...
                                </option>
                                <option value="فرزند">فرزند</option>
                                <option value="همسر">همسر</option>
                                <option value="پدر">پدر</option>
                                <option value="مادر">مادر</option>
                                <option value="خواهر">خواهر</option>
                                <option value="برادر">برادر</option>
                              </select>
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={row.column3}
                                onChange={(e) =>
                                  handleInputChange(e, row.id, index, "idcode")
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={row.column4}
                                onChange={(e) =>
                                  handleInputChange(e, row.id, index, "bd")
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button
                      className="btn btn-primary pl-1"
                      onClick={handleAddRow}
                    >
                      +افزودن سطر جدید
                    </button>
                  </div>
                )}
              </Col>
            </Row>
            <Col
              className=" m-2 col-12 col-lg-12 d-flex gap-2 align-items-center"
              dir="ltr"
            >
              <Button variant="primary" type="submit">
                ذخیره
              </Button>
            </Col>
          </Form>
        </>
      </PanelContainer>
    </>
  );
};

export default InsuranceForm;

const formData = {
  "First Name": "John",
  "Last Name": "Doe",
  Email: "john.doe@example.com",
  "Phone Number": "123-456-7890",
};

// <div className="container">
//   <h2>بیمه نامه</h2>
//   <div className="row">
//     <div className="col-md-6">
//       <div className="card">
//         <div className="card-body">
//           {Object.entries(formData).map(([fieldName, fieldValue]) => (
//             <div className="row mb-3" key={fieldName}>
//               <div className="col-6">
//                 <strong>{fieldName}</strong>
//               </div>
//               <div className="col-6">
//                 <span>{fieldValue}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//     <div className="col-md-6">
//       <div className="card">
//         <div className="card-body">
//           {Object.entries(formData).map(([fieldName, fieldValue]) => (
//             <div className="row mb-3" key={fieldName}>
//               <div className="col-6">
//                 <strong>{fieldName}</strong>
//               </div>
//               <div className="col-6">
//                 <span>{fieldValue}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   </div>
// </div>
